import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAthleteManagers,
  removeManager,
} from "../../store/actions/managerAction";
import { Button, Card, Container, Table } from "reactstrap";

const AthleteManager = () => {
  // const [loader, setLoader] = useState(true);
  const [loader, setLoader] = useState({
    dataLoader: true,
  });

  let dispatch = useDispatch();
  const { uid, user } = useSelector((state) => state.authUser);
  const { athleteManager } = useSelector((state) => state.manager);

  useEffect(() => {
    dispatch(
      getAthleteManagers(uid, () => {
        // setLoader(false);
        setLoader((prev) => ({
          ...prev,
          dataLoader: false,
        }));
      })
    );
  }, []);

  const handelRemove = (id) => {
    dispatch(removeManager(id));
  };
  return (
    <Container className="my-4">
      <Card className="p-2">
        {loader.dataLoader ? (
          <div className="text-center">
            <i className="spinner-border text-primary my-3"></i>{" "}
          </div>
        ) : (
          <Table className="table mt-3 align-items-center" responsive>
            <thead>
              <tr>
                <th scope="col" className="custom-table-heading">
                  Manager Name
                </th>
                <th scope="col" className="custom-table-heading">
                  Manager Email
                </th>
                <th scope="col" className="custom-table-heading">
                  Action
                </th>
              </tr>
            </thead>
            {athleteManager.length > 0 ? (
              athleteManager.map((ele, index) => (
                <tbody key={index}>
                  <tr>
                    <td className="custom-table-text">{ele.name}</td>
                    <td className="custom-table-text">{ele.email}</td>
                    <td className="custom-table-text whitespace-nowrap">
                      <Button
                        color="primary"
                        onClick={() => handelRemove(ele.id)}
                        disabled={ele.btnLoader}
                        className="whitespace-nowrap"
                      >
                        {ele.btnLoader ? (
                          <i className="spinner-border spinner-border-sm text-white "></i>
                        ) : (
                          "Remove"
                        )}
                      </Button>
                    </td>
                  </tr>
                </tbody>
              ))
            ) : (
              <tr>
                <td className="custom-table-text">N/A</td>
                <td className="custom-table-text">N/A</td>
                <td className="custom-table-text">N/A</td>
              </tr>
            )}
          </Table>
        )}
      </Card>
    </Container>
  );
};

export default AthleteManager;
